module.exports = __webpack_public_path__ + "img/ring_0_0_1_1@2x.9bf19f59.png";